import config from "config/config";
import { Banner } from "models/dashboard/dashboard";
import { apiRequest } from "./apiInterceptor";

export class BannersAPI {
  static async getBannersList(): Promise<Banner[]> {
    const response = await apiRequest
      .get(config.api.banners.getAll())
      .send();
    return response.body;
  }
}
